import * as actions from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import * as selectors from "./selectors"

const name = `plan`

export { name, actions, reducer, selectors, saga }
